import type NumberUnit from '@exodus/currency';
import { formatAssetAmount } from '@exodus/formatting/lib/asset';
import Box from '@passkeys/ui/box';
import Skeleton from '@passkeys/ui/skeleton';
import Text from '@passkeys/ui/text';

import type { Asset } from '@/types';
import TokenPickerButton from '@/ui/components/token-picker-button';
import { formatFiat } from '@/ui/utils/formatting';

export interface ToTokenProps {
  amount?: NumberUnit;
  token: Asset;
  fee?: number;
  loading: boolean;
  onTokenSelect: () => void;
}

function ToToken({
  amount,
  token,
  fee,
  loading = false,
  onTokenSelect,
}: ToTokenProps) {
  return (
    <div className="flex w-full flex-col items-center gap-y-2 pb-8 pt-4">
      <Text size={14}>You receive</Text>
      <Box className="flex w-full flex-col p-3">
        <div className="flex items-center justify-between border-b border-solid border-black/6 pb-2 theme-dark:border-neutral-600">
          <TokenPickerButton
            onClick={onTokenSelect}
            selected={token}
            dataTestId="buy-token-picker-button"
          />
          {loading ? (
            <Skeleton width={96} height={16} />
          ) : (
            <Text dataTestId="buy-token-amount">
              {amount && formatAssetAmount(amount.toDefaultNumber())}
            </Text>
          )}
        </div>
        <div className="flex items-center justify-between pt-2">
          <Text
            className="text-gray-500 theme-dark:text-neutral-200"
            size={13}
            monospace
          >
            Network Fee
          </Text>

          {loading ? (
            <Skeleton width={48} height={13} />
          ) : (
            <Text
              className="text-gray-500 theme-dark:text-neutral-200"
              size={13}
              dataTestId="buy-network-fee"
              monospace
            >
              {fee ? formatFiat(fee) : 'Might apply'}
            </Text>
          )}
        </div>
      </Box>
      <Text className="text-gray-400 theme-dark:text-neutral-200" size={13}>
        All amounts are estimated
      </Text>
    </div>
  );
}

export default ToToken;
